import styled from "styled-components";

export const Section = styled.section`
  width: 100%;
  display: grid;
  align-items: center;
  align-self: center;
  justify-content: center;
`

export const GamesCardsArea = styled.div`
  max-width: 1000px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

export const PageInfo = styled.div`
  display: grid;
  padding-left: 10px;
  padding-right: 10px;
  color: black;
  font-weight: 500;
  background: white;
  align-items: center;
  border-radius: 3px;
`;

export const InfoArea= styled.div`
  margin-top: 1rem;
  display: flex;
  width: 18rem;
  justify-content: space-between;
  jusfify-self: center;
`;